import React from 'react'
import { CoreTextField } from 'src/components/core'

export const SearchBar = ({ value, onChange }) => (
  <CoreTextField
    fullWidth={false}
    label="Search"
    size="small"
    value={value}
    onChange={e => onChange(e.target.value)}
    marginTop={0}
  />
)
